import axios from 'axios'

axios.defaults.withCredentials = true


const actions = {
  list_of_coop_savings_protect_pricing({rootGetters}, data) {
    axios.defaults.baseURL = rootGetters['system_data/url']
    return new Promise((resolve, reject) => {
      axios.post('api/list_of_coop_savings_protect_pricing', data)
        .then(response => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}

export default {
  namespaced: true,
  actions,
}
